import React from "react";
import { Box, Typography, Paper, IconButton, Button, Tooltip } from "@mui/material";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import StarsIcon from "@mui/icons-material/Stars";

export default function TicketCard({ 
  ticket, 
  isMain, 
  onSelect, 
  onRemove,
  goToCalled,
  showAddIcon = false,
  canRemove = true
}) {
  const handleIconClick = (e) => {
    e.stopPropagation();
    
    if (showAddIcon) {
      onSelect();
    } else if (onRemove && canRemove) {
      onRemove();
    }
  };

  const openCalledNewPage = () => {
    return;
  }

  const handleClickGoToCalled = (e) => {
    e.stopPropagation();
    goToCalled();
  }

  return (
    <Paper
      elevation={0}
      sx={{
        border: "1px solid #E5E8ED",
        borderRadius: "8px",
        p: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        cursor: showAddIcon ? "default" : "pointer",
        "&:hover": {
          borderColor: "#BFC6D0"
        }
      }}
    >
      {/* Ícone da esquerda */}
      <Box
        sx={{
          width: 28,
          height: 28,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mr: 2
        }}
      >
        {showAddIcon ? (
          <IconButton
            size="small"
            onClick={handleIconClick}
            sx={{
              p: 0,
              "&:hover": {
                backgroundColor: "transparent"
              }
            }}
          >
            <AddCircleOutlineIcon 
              sx={{ 
                color: "#4CAF50", 
                fontSize: 24,
                cursor: "pointer",
                "&:hover": {
                  color: "#45a049"
                }
              }} 
            />
          </IconButton>
        ) : (
            <Tooltip title={canRemove ? "Remover chamado" : "Não é possível remover o chamado"} arrow>
              <IconButton
                size="small"
                onClick={handleIconClick}
                disabled={!canRemove}
                sx={{
                  p: 0,
                  "&:hover": {
                    backgroundColor: "transparent"
                  }
                }}
              >
                <RemoveCircleOutlineIcon
                  sx={{
                    color: canRemove ? "#F19999" : "#E0E0E0",
                    fontSize: 24,
                    cursor: canRemove ? "pointer" : "not-allowed",
                    "&:hover": {
                      color: canRemove ? "#e87c7c" : "#E0E0E0"
                    }
                  }}
                />
              </IconButton>
            </Tooltip>
        )}
      </Box>

      {/* Conteúdo */}
      <Box flex={1} onClick={!showAddIcon ? onSelect : undefined}>
        <Button onClick={handleClickGoToCalled}>
          <Typography 
            sx={{
              fontSize: 15,
              fontWeight: 500,
              color: "#1E6BD6",
              textDecoration: "underline",
              cursor: "pointer",
              mb: 0.5
            }}
          >
            #{ticket.id}
          </Typography>
        </Button>
       

        <Typography
          component="div"
          sx={{
            fontSize: 15,
            fontWeight: 500,
            //color: "#1E6BD6",
            //textDecoration: "underline",
            //cursor: "pointer"
            mb: 2
          }}
          onClick={openCalledNewPage}
        >
          {ticket.title}
        </Typography>

        <Typography sx={{ fontSize: 13, color: "#8993A5", mt: 0.5 }}>
          Organização: {ticket.organizationname}
        </Typography>

         <Typography sx={{ fontSize: 13, color: "#8993A5", mt: 0.5 }}>
          Agente: {ticket.assignedusername ?? "Não atribuído"}
        </Typography>

        <Typography sx={{ fontSize: 13, color: "#A4ACB8", mt: 0.5 }}>
          {ticket.createdAt}
        </Typography>
      </Box>

      {/* Ícone do Principal */}
      {isMain && (
        <Box textAlign="center" ml={2}>
          <StarsIcon
            sx={{
              color: "#1E6BD6",
              fontSize: 28
            }}
          />
          <Typography
            variant="caption"
            sx={{ color: "#1E6BD6", display: "block", mt: 0.3 }}
          >
            Principal
          </Typography>
        </Box>
      )}
    </Paper>
  );
}